export default __webpack_public_path__ + "static/media/company.8d9ce013.svg";